import React from "react";
import { useLoader } from "../../../contexts/LoaderContext";

const GlobalLoader = () => {
  const { loading } = useLoader();

  if (!loading) return null;

  return (
    // <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
    //   <div className="relative w-16 h-16">
    //     <div className="absolute inset-0 border-4 border-t-transparent border-b-transparent border-blue-500 rounded-full animate-spin"></div>
    //     <div className="absolute inset-2 bg-white rounded-full"></div>
    //   </div>
    // </div>
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 z-50">
      <div className="relative w-16 h-16">
        <div
          className="absolute inset-0 rounded-full animate-spin"
          style={{
            background: "conic-gradient(from 0deg, #6366f1, #ec4899, #f59e0b)",
          }}
        ></div>
        <div className="absolute inset-2 bg-white rounded-full"></div>
      </div>
    </div>
    
  );
};

export default GlobalLoader;
